<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="sm" :visible="modal.show" :data="dateRange"
                   :title="title" @show="onShow"
                   @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')" :is-loading="loading">
      <date-range-picker
        class="my-3"
        style="width: 100%"
        showWeekNumbers
        showDropdowns
        ref="picker"
        :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy HH:mm:ss' }"
        v-model="dateRange">
        <template v-slot:input="picker" style="min-width: 350px;">
          <span v-if="!picker.startDate" class="text-muted">
            {{ $t('Date Range') }}
          </span>
          <span v-else>{{ picker.startDate | toDate }} - {{ picker.endDate | toDate }}</span>
        </template>
      </date-range-picker>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import ArtisioModal from "@/core/components/artisio-modal/ArtisioModal";
  import Spinner from "@/core/components/common/Spinner";
  import DateRangePicker from 'vue2-daterange-picker'
  import {createNamespacedHelpers} from "vuex";
  import moment from "moment";

  const {mapState, mapActions} = createNamespacedHelpers('global');

  export default {
    name: "DateRangeModal.vue",
    components: {
      ArtisioModal, Spinner, DateRangePicker
    },
    props: {
      submitHandler: {
        type: Function,
        required: true
      },
      title: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        dateRange: {startDate: null, endDate: null}
      }
    },
    computed: {
      ...mapState({
        modal: state => state.dateRangeModal,
      })
    },
    methods: {
      ...mapActions(['hideDateRangeModal']),
      onShow() {
        this.loading = false;
        this.showConfirmation = true
      },
      onHidden() {
        this.dateRange = {startDate: null, endDate: null}
        this.hideDateRangeModal();
      },
      async onSubmit() {
        this.loading = true;
        const selection = {
          date_after: this.dateRange.startDate ? moment(this.dateRange.startDate).format("YYYY-MM-DD") : null,
          date_before: this.dateRange.endDate ? moment(this.dateRange.endDate).format("YYYY-MM-DD") : null
        };
        const res = this.submitHandler(selection);
        if (res instanceof Promise) {
          res.then(() => this.loading = false).catch(() => this.loading = false)
        } else {
          this.loading = false;
        }
      },
    }
  }
</script>

<style scoped>

</style>